module.exports = __webpack_public_path__ + "static/media/view-and-create.2eb03ce6.svg";